import React from 'react';
import { createForm } from 'rc-form';
import styles from './index.less';

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
        ...props.time
    }
  }
  componentWillMount() {
    this.setTimeDown();
  }

  componentWillReceiveProps(props) {
    this.setState({
        ...props.time
    });
  }

  setTimeDown= () => {
    
    setTimeout(() => {
        const { hour,  minute, second} = this.state;
        if(hour === 0 && minute === 0 && second === 0) {
          return;
        }
        let newHour = hour, newMinute = minute, newSecond = second;
        if(second>0) {
            newSecond = newSecond - 1;
        }
        else {
            if(newMinute > 0) {
                newMinute = newMinute - 1
            }
            else {
                newMinute = 59
                newHour = newHour - 1
            }
            newSecond = 59;
        }
        newHour = newHour < 0 ? 0 : newHour;
        this.setState({
            hour: newHour,
            minute: newMinute,
            second: newSecond
        });
        if(!(newHour === 0 && newMinute === 0 && newSecond === 0)) {
            this.setTimeDown();
        }
        else {
            this.props.triggerTimeOver();
        }
    }, 995);
  }
  
  render() {

    const { hour,  minute, second} = this.state;
    return (
        <span className={styles.CounDown}>
          <span className={'time'}>{hour < 10 ? '0'+hour : hour}</span>
          <span>:</span>
          <span className={'time'}>{minute < 10 ? '0' + minute : minute}</span>
          <span>:</span>
          <span className={'time'}>{second < 10 ? '0' + second : second}</span>
        </span>
    );
  }
}

export default createForm()(Login);


// WEBPACK FOOTER //
// ./src/components/Countdown/index.js